export default __webpack_public_path__ + "static/media/Roboto-Medium.9e806dde.eot";